/* eslint-disable */

export const hasUpdates = (componentToEdit, componentToUpdate) => {
  switch (true) {
    case componentToEdit.type === 'Photo':
      return hasUpdatesCanvasPhoto(componentToEdit, componentToUpdate);
    case componentToEdit.type === 'Video':
      return hasUpdatesCanvasVideo(componentToEdit, componentToUpdate);
    case componentToEdit.type === 'Carousel':
      return hasUpdatesCanvasCarousel(componentToEdit, componentToUpdate);
    default:
      break;
  }

  return false;
};

export const hasUpdatesCanvasPhoto = (componentToEdit, componentToUpdate) => {
  return (
    componentToEdit.imageTargetUrl !== componentToUpdate.imageTargetUrl ||
    componentToEdit.name !== componentToUpdate.name ||
    componentToEdit.radioFit !== componentToUpdate.radioFit ||
    componentToEdit.url !== componentToUpdate.url
  );
};

export const hasUpdatesCanvasVideo = (componentToEdit, componentToUpdate) => {
  return (
    componentToEdit.name !== componentToUpdate.name ||
    componentToEdit.radioFitVideo !== componentToUpdate.radioFitVideo ||
    componentToEdit.url !== componentToUpdate.url
  );
};

export const hasUpdatesCanvasCarousel = (
  componentToEdit,
  componentToUpdate
) => {
  return (
    componentToEdit.name !== componentToUpdate.name ||
    componentToEdit.radioFitCarousel !== componentToUpdate.radioFitCarousel ||
    hasUpdatesCanvasCarouselCards(
      componentToEdit.cards,
      componentToUpdate.cards
    )
  );
};

export const hasUpdatesCanvasCarouselCard = (cardToEdit, cardToUpdate) => {
  return (
    cardToEdit.cardTargetUrl !== cardToUpdate.cardTargetUrl ||
    cardToEdit.cardName !== cardToUpdate.cardName ||
    cardToEdit.cardImageUrl !== cardToUpdate.cardImageUrl
  );
};

export const hasUpdatesCanvasCarouselCards = (cardsToEdit, cardsToUpdate) => {
  if (cardsToEdit.length !== cardsToUpdate.length) {
    return true;
  } else {
    let hasUpdates = false;
    cardsToEdit.map((card, index) => {
      const cardToCompare = cardsToUpdate[index];
      hasUpdates =
        hasUpdates || hasUpdatesCanvasCarouselCard(card, cardToCompare);
    });

    return hasUpdates;
  }
};



// WEBPACK FOOTER //
// ./src/screens/Canvas/CanvasElementComparer.js